import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import StyledCard from "components/card/StyledCard";

import {black500} from "assets/jss/main";

SideCard.propTypes = {
    titleId: PropTypes.string.isRequired,
    action: PropTypes.node,
};

function SideCard({titleId, action, children}) {
    return (
        <StyledCard noHoverShadow style={{marginBottom: "16px"}}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px"}}>
                <div style={{fontWeight: 700, color: black500, fontSize: "15px"}}><FormattedMessage id={titleId} /></div>
                {action}
            </div>
            {children}
        </StyledCard>
    );
}

export default SideCard;
